import { Link } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { useSite } from "@/lib/content";

export default function AdminBar() {
  const { mode, setMode } = useSite();
  const btn = (m, label) => (
    <button
      type="button"
      onClick={() => setMode(m)}
      aria-pressed={mode === m}
      className={`min-h-[44px] px-3 rounded-full text-xs font-semibold transition-colors ${mode === m ? "bg-gold-light text-forest-dark" : "text-cream/80 hover:text-cream"}`}
      data-testid={`admin-bar-mode-${m}`}
    >
      {label}
    </button>
  );
  return (
    <div className="safe-top bg-forest-dark text-cream" data-testid="admin-bar">
      <div className="safe-x max-w-7xl mx-auto flex items-center justify-between gap-3 py-0.5">
        <span className="text-xs font-medium hidden sm:inline">Yönetici görünümü</span>
        <div className="flex items-center gap-1 rounded-full bg-white/10 p-0.5" role="group" aria-label="Görünüm">
          {btn("preview", "Önizleme")}
          {btn("live", "Canlı")}
        </div>
        <Link to="/yonetim" className="inline-flex items-center gap-1.5 min-h-[44px] text-xs font-semibold text-gold-light hover:underline" data-testid="admin-bar-panel-link">
          <Settings2 className="h-3.5 w-3.5" aria-hidden="true" /> Yönetim paneli
        </Link>
      </div>
    </div>
  );
}
